const state = {
  id: null,
  permissions: [],
};

const getters = {
  /**
   * Return the membership id of the current user
   */
  getCurrentMembershipId(state) {
    return state.id;
  },

  /**
   * Return the permissions of the current user
   */
  getCurrentMembershipPermissions(state) {
    return state.role?.permissions_keys;
  },
};

const module = {
  namespaced: true,
  state,
  getters,
};

export default module;
